import React from 'react'
import { Tooltip } from 'antd'

function GroupBubble({ image = '', member_count = '', className = '' }) {
    return (
        <Tooltip title={`${member_count} Members`}>
            <img className={className} src={image} alt={`${member_count} Members`} />
        </Tooltip>
    )
}

export default GroupBubble